import React from 'react';

import { Box, Chip, ChipProps, Link, Typography } from '@mui/material';
import _ from 'es-toolkit/compat';

import { UserStatus } from 'src/api';
import { UserStatusChip } from 'src/components/common';

export const ChipSection: React.FC = () => {
  return (
    <Box component="section">
      <Typography variant="h3">Chip</Typography>

      <Box mt={2}>
        <Box display="flex" gap={2}>
          {chipColors.map(chipColor => (
            <Chip key={chipColor} color={chipColor} label={_.capitalize(chipColor)} />
          ))}
        </Box>

        <Box display="flex" gap={2} mt={2}>
          {Object.entries(UserStatus).map(userStatusEntry => (
            <UserStatusChip key={userStatusEntry[0]} userStatus={userStatusEntry[1]} />
          ))}
        </Box>

        <Box mt={2}>
          For more examples see <Link href="https://mui.com/material-ui/react-chip/">mui.com</Link>
        </Box>
      </Box>
    </Box>
  );
};

type ChipColor = NonNullable<ChipProps['color']>;
const chipColors: ChipColor[] = [
  'default',
  'error',
  'info',
  'primary',
  'secondary',
  'success',
  'warning',
];
